<template>
  <div class="mx-auto max-w-screen-lg">
    <img class="w-full" :src="require('./top.jpg')" />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!-- 轮播 -->
      <div class="swiper mt-3">
        <van-swipe :autoplay="3000" @change="onChange">
          <van-swipe-item v-for="(item, index) in swiperData" :key="index">
            <img
              width="100%"
              :src="item.image ? item.image : ''"
              @click="jumpPage(item.share_url || item.url)"
            />
            <span class="swiper_txt md:text-lg text-sm van-ellipsis">{{
              item.title
            }}</span>
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">
              <span
                v-for="(item, index) in swiperData"
                :key="index"
                :class="{ active: current === index }"
              ></span>
            </div>
          </template>
        </van-swipe>
      </div>
      <!-- 主要内容 -->
      <div class="p-2 md:p-0">
        <!-- 列表 -->
        <!-- 加载更多的列表 -->
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="initListContent"
          :van-clearfix="true"
          :immediate-check="false"
        >
          <div v-for="item in listData" :key="item.id">
            <!-- 加载更多的列表 -->
            <div
              class=""
              v-if="!(item.card_type == 100 || item.card_type == 200)"
            >
              <div class="">
                <!-- 无图 -->
                <template v-if="item.card_type == 0">
                  <div
                    class="
                      my-2
                      p-2
                      flex flex-col
                      border-b border-gray-200
                      pb-3
                      md:pb-3
                    "
                  >
                    <p
                      class="
                        van-multi-ellipsis--l2
                        md:text-3xl md:leading-loose
                        text-base
                        w-full
                        cursor-pointer
                        leading-relaxed
                      "
                      @click="jumpPage(item.share_url || item.url)"
                    >
                      {{ item.title }}
                    </p>
                    <p
                      class="
                        van-multi-ellipsis--l2
                        mt-2
                        md:text-lg
                        text-base
                        md:leading-loose
                        hidden
                      "
                    >
                      {{ item.desc }}
                    </p>
                    <div
                      class="
                        w-full
                        md:text-sm
                        text-xs text-gray-500
                        mt-2
                        justify-between
                        flex
                      "
                    >
                      <span class="van-ellipsis pr-2">
                        {{ item.src }}
                      </span>
                      <span class="flex-shrink-0">
                        {{ item.pub_time }}
                      </span>
                    </div>
                  </div>
                </template>
                <!-- 小图 -->
                <template v-if="item.card_type == 1">
                  <div class="my-2 p-2">
                    <div class="flex border-b border-gray-200 pb-3 md:pb-3">
                      <div
                        class="
                          w-4/6
                          md:w-5/7
                          flex flex-col
                          content-between
                          justify-between
                          mr-2
                          md:mr-5
                        "
                      >
                        <div
                          class="
                            md:text-3xl md:leading-loose
                            text-base
                            w-full
                            van-multi-ellipsis--l2
                            leading-relaxed
                            cursor-pointer
                          "
                          @click="jumpPage(item.share_url || item.url)"
                        >
                          {{ item.title }}
                        </div>
                        <p
                          class="
                            van-multi-ellipsis--l2
                            mt-2
                            md:text-lg
                            text-base
                            hidden
                            md:leading-loose
                          "
                        >
                          {{ item.desc }}
                        </p>
                        <div
                          class="
                            w-full
                            md:text-sm
                            text-xs text-gray-500
                            mt-2
                            justify-between
                            flex
                          "
                        >
                          <span class="van-ellipsis pr-2">
                            {{ item.src }}
                          </span>
                          <span class="flex-shrink-0">
                            {{ item.pub_time }}
                          </span>
                        </div>
                      </div>
                      <div class="w-2/6 md:w-2/7 cursor-pointer">
                        <van-image
                          lazy-load
                          fit="fill"
                          :src="item.image"
                          radius="0.3rem"
                          @click="jumpPage(item.share_url || item.url)"
                        >
                          <template v-slot:loading>
                            <van-loading type="spinner" size="20" />
                          </template>
                        </van-image>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 大图 -->
                <template v-if="item.card_type == 2">
                  <div
                    class="
                      my-2
                      p-2
                      flex flex-col
                      border-b border-gray-200
                      pb-3
                      md:pb-3
                    "
                  >
                    <p
                      class="
                        md:text-3xl md:leading-loose
                        text-base
                        w-full
                        van-multi-ellipsis--l2
                        leading-relaxed
                        cursor-pointer
                      "
                      @click="jumpPage(item.share_url || item.url)"
                    >
                      {{ item.title }}
                    </p>
                    <div class="mt-2 cursor-pointer">
                      <van-image
                        lazy-load
                        fit="fill"
                        width="100%"
                        :src="item.image"
                        radius="0.3rem"
                        @click="jumpPage(item.share_url || item.url)"
                      >
                        <template v-slot:loading>
                          <van-loading type="spinner" size="20" />
                        </template>
                      </van-image>
                    </div>
                    <div
                      class="
                        w-full
                        md:text-sm
                        text-xs text-gray-500
                        mt-2
                        justify-between
                        flex
                      "
                    >
                      <span class="van-ellipsis pr-2">
                        {{ item.src }}
                      </span>
                      <span class="flex-shrink-0">
                        {{ item.pub_time }}
                      </span>
                    </div>
                  </div>
                </template>
                <!-- 三图 -->
                <template v-if="item.card_type == 3">
                  <div
                    class="
                      my-2
                      p-2
                      flex flex-col
                      border-b border-gray-200
                      pb-3
                      md:pb-3
                    "
                  >
                    <p
                      class="
                        md:text-3xl md:leading-loose
                        text-base
                        w-full
                        van-multi-ellipsis--l2
                        leading-relaxed
                        cursor-pointer
                      "
                      @click="jumpPage(item.share_url || item.url)"
                    >
                      {{ item.title }}
                    </p>
                    <div class="flex flex-row mt-2">
                      <div
                        class="w-1/3 px-1 md:px-3 cursor-pointer"
                        v-for="(elem, index) in item.images"
                        :key="index"
                      >
                        <van-image
                          lazy-load
                          fit="fill"
                          class=""
                          radius="0.3rem"
                          style="height: 100%"
                          :src="elem"
                          @click="jumpPage(item.share_url || item.url)"
                        >
                          <template v-slot:loading>
                            <van-loading type="spinner" size="20" />
                          </template>
                        </van-image>
                      </div>
                    </div>
                    <div
                      class="
                        w-full
                        md:text-sm
                        text-xs text-gray-500
                        mt-2
                        justify-between
                        flex
                      "
                    >
                      <span class="van-ellipsis pr-2">
                        {{ item.src }}
                      </span>
                      <span class="flex-shrink-0">
                        {{ item.pub_time }}
                      </span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { getInfomationList } from "@/request/api";

import { navigate2 } from "@/pages/index/custom";

export default {
  components: {},
  data() {
    return {
      id: 152,
      // 轮播
      current: 0,
      swiperData: [],
      isLoading: false,
      listData: [],
      listPage: 1,
      loading: true, // 加载中
      finished: false, // 加载完毕
    };
  },
  methods: {
    // 详情页跳转
    jumpPage(url) {
      navigate2("", url);
    },
    onChange(index) {
      this.current = index;
    },
    // 获取列表内容
    initListContent() {
      getInfomationList({
        chan_id: this.id,
        page: this.listPage,
        pcount: 10,
        is_h5: 1,
      })
        .then((res) => {
          let { data, focus, error_code } = res;
          this.isLoading = false;
          if (error_code === 0) {
            if (data.length === 0 || !data) {
              this.finished = true;
              return false;
            }
            if (this.listPage === 1) {
              this.swiperData = [];
              for (const item of focus) {
                this.swiperData.push(item);
              }
              this.listData = data;
            } else {
              data.map((item) => this.listData.push(item));
            }
            this.listPage++;
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    // 上拉刷新
    onRefresh() {
      this.swiperData = [];
      this.listData = [];
      this.listPage = 1;
      this.loading = true;
      this.finished = false;
      this.initListContent();
    },
  },
  created() {
    this.initListContent();
  },
};
</script>

<style lang="less" scoped>
.w-l {
  width: 72%;
}
.w-r {
  width: 28%;
}
.swiper {
  box-sizing: border-box;
  position: relative;
  .swiper_txt {
    position: absolute;
    left: 0;
    bottom: 12px;
    box-sizing: border-box;
    padding: 0 0.75rem;
    width: 100%;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }
}
.van-swipe-item {
  width: 100%;
  position: relative;
  overflow: hidden;
}
.van-swipe {
  position: static;
  border-radius: 8px;
  overflow: hidden;
}
.van-image {
  display: block;
}
.custom-indicator {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  span {
    width: 1.875rem;
    height: 0.125rem;
    background-color: #eee;
    &.active {
      background-color: #ff4c67;
    }
  }
}
</style>
